const orderTempConstants = {
	SET_STATE_FIELD_VALUE: "SET_STATE_FIELD_VALUE",
	CLEAR_TEMP_PROJECT: "CLEAR_TEMP_PROJECT",
	SET_TEMP_PROJECT: "SET_TEMP_PROJECT",
	SET_INIT_NUMBER_OF_BUILDINGS: "SET_INIT_NUMBER_OF_BUILDINGS",
	UPDATE_BUILDING: "UPDATE_BUILDING",
	UPDATE_BUILDING_DATA: "UPDATE_BUILDING_DATA",
	SET_EXPORTS: "SET_EXPORTS",
	UPDATE_PRICE: "UPDATE_PRICE",
	REMOVE_BUILDING: "REMOVE_BUILDING",
	SET_STATE_FROM_PACKAGE: "SET_STATE_FROM_PACKAGE",
	SET_TEMP_TERMS_AND_CONDITIONS: "SET_TEMP_TERMS_AND_CONDITIONS",
	SET_TEMP_ADDITIONAL_INFO: "SET_TEMP_ADDITIONAL_INFO",
	UPDATE_PRICE_PER_SQUARE_PERCENTAGE: "UPDATE_PRICE_PER_SQUARE_PERCENTAGE",
	UPDATE_EXPORT_PRICE_PERCENTAGE: "UPDATE_EXPORT_PRICE_PERCENTAGE",
	SET_COMPANY_STATE_FIELD_VALUE: "SET_COMPANY_STATE_FIELD_VALUE",
	CLEAR_COMPANY_STATE_VALUE: "CLEAR_COMPANY_STATE_VALUE",
	SET_TEMP_COMPANY_INFO: "SET_TEMP_COMPANY_INFO",
	UPDATE_BUILDING_PRICE: "UPDATE_BUILDING_PRICE",
	SET_STATE_FROM_PACKAGE_CONFIGURATION: "SET_STATE_FROM_PACKAGE_CONFIGURATION",
	UPDATE_CREATE_OFFER_LEVELS: "UPDATE_CREATE_OFFER_LEVELS",
	SET_CREATE_ORDER_FILE_PER_LEVEL: "SET_CREATE_ORDER_FILE_PER_LEVEL",
	SET_TEMP_CREATE_ORDER_FILES: "SET_TEMP_CREATE_ORDER_FILES",
	//Reset
	RESET_SUMMARY_VIEW: "RESET_SUMMARY_VIEW",
	RESET_ORDER_VIEW: "RESET_ORDER_VIEW",
	RESET_MODELS_VIEW: "RESET_MODELS_VIEW",
	RESET_EXPORTS_VIEW: "RESET_EXPORTS_VIEW",
	RESET_SUMMARY_PRICE_VIEW: "RESET_SUMMARY_PRICE_VIEW",
	RESET_BIM_SPECIFICATION_VIEW: "RESET_BIM_SPECIFICATION_VIEW",
};

export default orderTempConstants;
